import moment from 'moment';
import countries from '@/utils/countries';
import states from '@/utils/states';

export default {

    data() {
        return {
            states,
            countries,
            taxRate: 0,
            cardSetupComplete: false,
            form: {
                billing_country: 'USA',
                billing_state: null,
            },
        };
    },

    computed: {

        firstBillingDate() {
            return moment().add(90, 'days').format('MMMM D, YYYY')
        },

        yearlyPricing() {
            return parseInt(this.form.max_children, 10) === 4 ? 100 : 150;
        },

        monthlyPricing() {
            return parseInt(this.form.max_children, 10) === 4 ? 10 : 15;
        },

        canShowBillingInfo() {
            if (this.type === 'STANDARD') {
                if (this.form.billing_country != 'USA') {
                    return this.cardSetupComplete;
                }

                return this.cardSetupComplete && !!this.form.billing_state;
            }

            return false;
        }

    },

    methods: {

        cardCompleted(token) {
            this.form.token = token;
            this.form.billing_zip = token.card.address_zip;
            this.cardSetupComplete = true;

            this.getTaxRate();
        },

        async getTaxRate() {
            if (!this.form.billing_state || !this.form.billing_zip) {
                this.taxRate = 0;
                return;
            }

            const { data } = await axios.post('/tax-rate/', { state: this.form.billing_state, zip: this.form.billing_zip } );

            if (data.success) {
                this.taxRate = data.rate;
            }
        },

        calculatedTax(amount) {
            if (this.taxRate > 0) {
                return ' + $' + parseFloat(amount * this.taxRate).toFixed(2) + ' sales tax ';
            }

            return '';
        },

    }

};



// WEBPACK FOOTER //
// ./resources/js/mixins/SubscriptionMixin.js